"use client";
import App from "@/components/client-app/App";
import { queryClient } from "@/configs/react-query";
import { LazoUserProvider } from "@/contexts/UserContext";
import ErrorBoundary from "@/routes/ErrorBoundary";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { useRouter } from "next/router";
import Script from "next/script";

export default function Home() {
  const router = useRouter();

  const handleGoBack = () => {
    router.back();
  };

  return (
    <>
      {/* Google Tag Manager */}
      <Script id="gtm-script" strategy="afterInteractive">
        {`
          (function(w,d,s,l,i){
            w[l]=w[l]||[];
            w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
            var f=d.getElementsByTagName(s)[0],
                j=d.createElement(s), dl=l!='dataLayer'?'&l='+l:'';
            j.async=true;
            j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
            f.parentNode.insertBefore(j,f);
          })(window, document, 'script', 'dataLayer', 'GTM-MSJ7H6MJ');
        `}
      </Script>

      {/* Google Analytics */}
      <Script src="https://www.googletagmanager.com/gtag/js?id=G-1SM4LHCEME" strategy="afterInteractive" />
      <Script id="ga-script" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-1SM4LHCEME');
        `}
      </Script>

      {/* GTM noscript fallback */}
      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-MSJ7H6MJ"
          height="0"
          width="0"
          style={{ display: "none", visibility: "hidden" }}
        />
      </noscript>

      <div className="inter-font">
        <QueryClientProvider client={queryClient}>
          <LazoUserProvider>
            <ErrorBoundary onGoBack={handleGoBack}>
              <App />
              <ReactQueryDevtools initialIsOpen={false} />
            </ErrorBoundary>
          </LazoUserProvider>
        </QueryClientProvider>
      </div>
    </>
  );
}
